import { Search } from "@replicate/ui";

interface SiteSearchProps {
  authState: "authenticated" | "anonymous";
  params?: {
    limit: number;
  };
  portal?: boolean;
  useSearchV2?: boolean;
}

export function SiteSearch({
  authState,
  params = { limit: 50 },
  portal = true,
  useSearchV2 = false,
}: SiteSearchProps) {
  return (
    <div className="w-full max-w-lg">
      <Search
        params={params}
        authState={authState}
        portal={portal}
        useSearchV2={useSearchV2}
      />
    </div>
  );
}
